import { useEffect, useState } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import FeaturedSection from "./components/FeaturedSection";
import DormSection from "./components/DormSection";
import ClassroomSection from "./components/ClassroomSection";
import RankingSection from "./components/RankingSection";
import DuoSection from "./components/DuoSection";
import GossipSection from "./components/GossipSection";
import FaqSection from "./components/FaqSection";
import SubmitSection from "./components/SubmitSection";
import Footer from "./components/Footer";

function BackTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="返回顶部"
      className={`fixed bottom-6 right-6 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-primary-500 text-white shadow-lg transition-all hover:bg-primary-600 ${
        show ? "opacity-100" : "pointer-events-none opacity-0"
      }`}
    >
      <i className="ri-arrow-up-line text-xl" />
    </button>
  );
}

export default function Home() {
  return (
    <div className="bg-background-50">
      <Header />
      <main>
        <Hero />
        <FeaturedSection />
        <DormSection />
        <ClassroomSection />
        <RankingSection />
        <DuoSection />
        <GossipSection />
        <FaqSection />
        <SubmitSection />
      </main>
      <Footer />
      <BackTop />
    </div>
  );
}